import * as Types from '../../../../_generated/types.d';

import { GeocodeResponseData } from "@googlemaps/google-maps-services-js";
import { CoachState } from "@portal/app/_common/lib/coach";
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
export type VocationForDreamSearchResultsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type VocationForDreamSearchResultsQuery = { __typename?: 'Query', vocation: { __typename?: 'Vocation', id: string, name: string } | null };


export const VocationForDreamSearchResultsDocument = gql`
    query vocationForDreamSearchResults($id: ID!) {
  vocation(id: $id) {
    id
    name
  }
}
    ` as unknown as DocumentNode<VocationForDreamSearchResultsQuery, VocationForDreamSearchResultsQueryVariables>;